export default {
      id: "icon-arrow-down-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-down",
      toString: function () {
        return this.url;
      }
    }